import React from 'react';
import { clsx } from 'clsx';

interface CounterpartyCardProps {
  name: string;
  availabilityStatus: string | null;
  recallStatus: string | null;
  sendTime: string | null;
  isSelected: boolean;
  onClick: () => void;
}

const STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  sent: 'Sent',
};

const statusStyles: Record<string, string> = {
  draft: 'bg-yellow-100 text-yellow-800',
  sent: 'bg-green-100 text-green-800',
};

const StatusBadge: React.FC<{ label: string; status: string | null }> = ({ label, status }) => (
  <span className="inline-flex items-center gap-1 text-xs text-gray-500">
    {label}:
    <span
      className={clsx(
        'inline-flex rounded-full px-1.5 py-0.5 text-[10px] font-medium leading-none',
        status ? (statusStyles[status] ?? 'bg-gray-100 text-gray-700') : 'bg-gray-100 text-gray-400'
      )}
    >
      {status ? (STATUS_LABELS[status] ?? status) : 'No report'}
    </span>
  </span>
);

export const CounterpartyCard: React.FC<CounterpartyCardProps> = ({
  name,
  availabilityStatus,
  recallStatus,
  sendTime,
  isSelected,
  onClick,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={clsx(
        'w-full rounded-lg border p-3 text-left transition-colors',
        isSelected
          ? 'border-primary-200 bg-primary-50 border-l-4 border-l-primary-600'
          : 'border-gray-200 bg-white hover:bg-gray-50'
      )}
    >
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-gray-900">{name}</span>
      </div>
      <div className="mt-1.5 flex flex-col gap-1">
        <StatusBadge label="Availability" status={availabilityStatus} />
        <StatusBadge label="Recall" status={recallStatus} />
      </div>
      {sendTime && (
        <div className="mt-1 text-xs text-gray-500">
          {sendTime}
        </div>
      )}
    </button>
  );
};
